const state = {
    searchValue: {
        areaName: '',
        dongName: '',
    },
    eupMyeonDongBoundaryInfo: {
        visibleList: {},
        currentInfo: {},
    },
    registeredAreaList: [],
    checkedAreaList2: [],
    checkedAreaList: {},
    selectedArea: {
        areaId: '',
        areaName: '',
    },
    isCreateAreaMode: false,
    currentPolygon: {
        coordinateList: [],
        needResetList: [],
    },
};
export default state;
